import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconDocument = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10.3125 0V3.75H14.0625L10.3125 0Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.4375 5.625H14.0625V14.0625C14.0625 14.625 13.6875 15 13.125 15H1.875C1.3125 15 0.9375 14.625 0.9375 14.0625V0.9375C0.9375 0.375 1.3125 0 1.875 0H8.4375V5.625Z",
		fill: "currentColor"
	})]
});
export default SvgIconDocument;
